import ShopThumbLayout from './ShopThumbLayout';
import ShopThumbLayoutContainer from './ShopThumbLayout.container';
export default ShopThumbLayoutContainer(ShopThumbLayout);
